export class StringHelper {
  static urlJoin(first, ...parts) {
    // สร้าง URL object จาก base
    const url = new URL(first)
    // ช่วยลบทั้ง leading และ trailing slash ออกจากแต่ละ segment
    const clean = parts.map((p) => p.replace(/(^\/+|\/+$)/g, ""))
    // เก็บ pathname ปัจจุบัน (ลบ slash สุดท้ายก่อน)
    const basePath = url.pathname.replace(/\/+$/g, "")
    // รวมเป็น path ใหม่
    url.pathname = [basePath, ...clean]
      .filter(Boolean) // กรองเอา empty strings ทิ้ง
      .join("/") // คั่นด้วย slash เดียว
    return url.toString()
  }

  static getSlugFromText = (str: string): string => {
    const regexpSpacialLetter: RegExp =
      /[\_|\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s]+/g
    return str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "")
      .replace(regexpSpacialLetter, "")
  }

  static getAliasFromText = (str: string): string => {
    const regexpSpacialLetter: RegExp =
      /[\_|\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s]+/g
    return str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "")
      .replace(/[ก-๙]/g, "")
      .replace(regexpSpacialLetter, "")
  }

  static getEventNameFromText = (str: string): string => {
    const regexpSpacialLetter: RegExp =
      /[\_|\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s]+/g
    return str
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/\-\-+/g, "_")
      .replace(/^-+/, "_")
      .replace(/-+$/, "_")
      .replace(/[ก-๙]/g, "")
      .replace(regexpSpacialLetter, "_")
  }

  static genString = (length: number = 5) => {
    let result = ""
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  static withComma = (value: number | string = 0): string => {
    return (+(value || 0)).toLocaleString()
  }

  static numberWithComma = (value: string): string => {
    if (!Number(value)) {
      return value
    }
    let val = (+(value || 0)).toLocaleString()
    return val
  }

  static insertTextInposition(
    originalText: string,
    insertText: string,
    position: number
  ) {
    let prefix = originalText.substring(0, position)
    let subfix = originalText.substring(position, originalText.length)
    return prefix + insertText + subfix
  }

  static copyToClipBoard = async (value: string = "") => {
    const text = `${value ?? ""}`

    if (!window.isSecureContext || !navigator.clipboard?.writeText) {
      throw new Error("Clipboard API is unavailable")
    }
    await navigator.clipboard.writeText(text)
  }

  static toPascalCase = (str: string): string => {
    return `${str}`
      .replace(new RegExp(/[-_]+/, "g"), " ")
      .replace(new RegExp(/[^\w\s]/, "g"), "")
      .replace(
        new RegExp(/\s+(.)(\w+)/, "g"),
        ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`
      )
      .replace(new RegExp(/\s/, "g"), "")
      .replace(new RegExp(/\w/), (s) => s.toUpperCase())
  }

  static capitalize = (str: string): string => {
    return `${str}`
      .replace(new RegExp(/[^\w\s]/, "g"), "")
      .replace(new RegExp(/[-_]+/, "g"), " ")
      .replace(
        new RegExp(/\s+(.)(\w+)/, "g"),
        ($1, $2, $3) => `${" " + $2.toUpperCase() + $3.toLowerCase()}`
      )
      .replace(new RegExp(/\w/), (s) => s.toUpperCase())
  }

  static toSnakeCase = (str: string): string => {
    return `${str}`.replace(new RegExp(/[\s]/, "g"), "_").toLowerCase()
  }

  static split = (
    str: string | null | undefined,
    separator: string | RegExp
  ): string[] => {
    return `${str || ""}`
      .split(separator)
      .filter((item: string) => item)
      .map((item: string) => item.trim())
  }

  static joinURL = (value: any, value2: any): string => {
    return StringHelper.urlJoin(value, value2)
  }

  static toString = (value: any): string => {
    return value || ""
  }

  static truncate = (str: any, num = 300) => {
    str = str || ""
    if (str.length > num) {
      return str.slice(0, num) + "..."
    } else {
      return str
    }
  }

  static genHTML(html = "", css = "", js = ""): string {
    const newCSS = css ? `<style>${css}</style>` : ""
    const newJS = js
      ? `<script type="text/javascript">window.onload=function(){${js}}</script>`
      : ""
    const newHTML = html || ""

    return `${newCSS}${newHTML}${newJS}`
  }
}
